import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material';

interface PathProps {
  label: string;
  route: string;
}
interface BreadcrumbProps {
  paths: PathProps[];
}

function Breadcrumb({ paths }: BreadcrumbProps) {
  //const location = useLocation();
  //const pathnames = location; // remove strings vazias
  const theme = useTheme();

  const breadcrumbs = paths.map(({ label, route }: PathProps) => {
    const to = route;

    return (
      <Link color="inherit" to={to} key={to}>
        {label}
      </Link>
    );
  });

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
      <Stack
        spacing={2}
        style={{
          width: '100%',
          paddingTop: '16px',
          paddingBottom: '16px',
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          separator="›"
          sx={{
            fontSize: '12px',
            color: theme.palette.fixed.grey,
            '& .MuiBreadcrumbs-li a': {
              // seleciona apenas os links dentro do breadcrumb
              color: theme.palette.fixed.grey,
              textDecoration: 'none',
              '&:hover': {
                color: theme.palette.primary['01'],
              },
              '&:active': {
                color: 'red',
              },
            },
          }}
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
    </Box>
  );
}

export default Breadcrumb;
